/** FAQ, Support, and Advertising page copy (Czech translation). */
export const pagesMessagesCs = {
  faq: {
    pageTitle: "Často kladené otázky",
    pageSubtitle: "Najděte odpovědi na časté otázky o WasOK",
    seoTitle: "Časté otázky — WasOK",
    seoDescription:
      "Odpovědi na časté otázky o WasOK, skenování produktů, ochraně soukromí a hodnocení.",
    items: [
      {
        question: "Jak funguje WasOK?",
        answer:
          "WasOK vám pomáhá pamatovat si, které produkty se vám líbily nebo nelíbily, tím, že skenuje čárové kódy a ukládá vaše hodnocení a poznámky. Jednoduše naskenujte čárový kód produktu, ohodnoťte ho, přidejte poznámky, a příště, když naskenujete stejný produkt, okamžitě uvidíte své předchozí hodnocení.",
      },
      {
        question: "Jsou má data uložena v cloudu?",
        answer:
          "Ne! Všechna vaše data jsou uložena lokálně ve vašem zařízení. Vaše informace nesynchronizujeme s cloudem, což znamená, že vaše nákupní historie a názory na produkty zůstávají zcela soukromé. To však také znamená, že byste měli zálohovat své zařízení, pokud chcete svá data zachovat.",
      },
      {
        question: "Potřebuji ke používání WasOK připojení k internetu?",
        answer:
          "Ne, WasOK funguje zcela offline. Protože jsou všechna vaše data uložena lokálně ve vašem zařízení, můžete skenovat produkty, přidávat hodnocení a prohlížet svou historii bez jakéhokoli připojení k internetu.",
      },
      {
        question: "Mohu WasOK používat pro jakýkoli typ produktu?",
        answer:
          "Ano! WasOK funguje s jakýmkoli produktem, který má čárový kód. Ať už jde o potraviny, kosmetiku, domácí potřeby, elektroniku nebo cokoli jiného s čárovým kódem, můžete to naskenovat a uložit si své názory.",
      },
      {
        question: "Jak naskenuji čárový kód?",
        answer:
          "Jednoduše otevřete aplikaci WasOK a klepněte na tlačítko skenování. Namiřte fotoaparát na čárový kód produktu a aplikace jej automaticky rozpozná a naskenuje. Pro nejlepší výsledky se ujistěte, že je čárový kód dobře osvětlený a zaostřený.",
      },
      {
        question: "Mohu ke svým hodnocením produktů přidávat fotografie?",
        answer:
          "Ano! Ke každému hodnocení produktu můžete připojit fotografie. To je obzvláště užitečné pro zapamatování detailů obalu, seznamu složek nebo jakýchkoli jiných vizuálních informací, které vám mohou pomoci vzpomenout si, proč se vám produkt líbil nebo nelíbil.",
      },
      {
        question: "Jaké informace mohu o produktech uložit?",
        answer:
          "Můžete ukládat hodnocení (1–5 hvězdiček), textové poznámky, fotografie, cenu, kterou jste zaplatili, místo nákupu a vlastní kategorie. Tyto komplexní informace vám pomohou činit informovaná rozhodnutí při nakupování.",
      },
      {
        question: "Mohu vytvářet nákupní seznamy?",
        answer:
          "Ano! WasOK vám umožňuje vytvářet nákupní seznamy z produktů, které jste již ohodnotili. Díky tomu snadno zapamatujete, které produkty jste milovali a chcete koupit znovu.",
      },
      {
        question: "Jak si organizuji své produkty?",
        answer:
          "Produkty můžete organizovat pomocí vlastních kategorií. Můžete si například vytvořit kategorie jako „Svačiny“, „Káva“, „Péče o pleť“ nebo „Čisticí prostředky“. Díky tomu snadno procházíte svá hodnocení podle typu.",
      },
      {
        question: "Je WasOK zdarma?",
        answer:
          "Ano, WasOK je zcela zdarma ke stažení a používání. Neexistují žádné nákupy v aplikaci, předplatné ani skryté poplatky. Věříme, že by každý měl mít přístup k soukromému způsobu, jak si pamatovat své preference produktů.",
      },
      {
        question: "Je WasOK přístupný?",
        answer:
          "WasOK je navržen tak, aby byl použitelný pro co nejvíce lidí. Aplikace obsahuje funkce přístupnosti, jako je podpora čtečky obrazovky, škálovatelný text a volitelný režim s vysokým kontrastem.",
      },
      {
        question: "Co se stane, když aplikaci odinstaluji?",
        answer:
          "Protože jsou všechna data uložena lokálně ve vašem zařízení, odinstalování aplikace smaže všechna vaše hodnocení produktů, poznámky a nákupní seznamy. Pokud si chcete před odinstalováním ponechat zálohu, nezapomeňte svá data exportovat.",
      },
      {
        question: "Mohu exportovat svá data?",
        answer:
          "Ano, WasOK vám umožňuje exportovat data pro účely zálohování. Můžete exportovat všechna svá hodnocení do souboru, který si můžete uložit do svého zařízení nebo do cloudového úložiště podle vašeho výběru.",
      },
      {
        question: "Sleduje WasOK moji polohu?",
        answer:
          "Ne, WasOK nesleduje vaši polohu. I když můžete ručně zadat název obchodu, kde jste produkt koupili, aplikace nepoužívá GPS ani služby určování polohy.",
      },
      {
        question: "Mohu WasOK používat na více zařízeních?",
        answer:
          "V současné době se WasOK mezi zařízeními nesynchronizuje, protože všechna data jsou uložena lokálně. Každé zařízení bude mít svou vlastní samostatnou databázi produktů a hodnocení.",
      },
      {
        question: "Co když se čárový kód nenaskenuje?",
        answer:
          "Pokud se čárový kód nenaskenuje, ujistěte se, že je dobře osvětlený a zaostřený. Můžete také zkusit vyčistit objektiv fotoaparátu. Pokud je čárový kód poškozený nebo nečitelný, možná budete moci zadat číslo čárového kódu ručně.",
      },
    ],
    cta: {
      heading: "Máte stále otázky?",
      body: "Obraťte se na náš tým podpory — rádi vám pomůžeme.",
      button: "Kontaktovat podporu",
    },
  },
  support: {
    pageTitle: "Podpora",
    seoTitle: "Podpora — WasOK",
    seoDescription:
      "Získejte pomoc s WasOK: kontaktujte podporu, nahlaste chyby a sdílejte zpětnou vazbu.",
    getHelp: {
      title: "Získat pomoc",
      body: "Jsme tu, abychom vám pomohli vytěžit z WasOK maximum. Pokud máte problémy nebo dotazy, máme k dispozici několik zdrojů, které vám mohou pomoci.",
    },
    faq: {
      title: "Často kladené otázky",
      body: "Než nás kontaktujete, podívejte se do naší sekce Časté otázky, kde odpovídáme na nejčastější dotazy o WasOK. Najdete zde podrobné informace o tom, jak aplikace funguje, o soukromí, ukládání dat a dalších tématech.",
    },
    contact: {
      title: "Kontaktovat podporu",
      body: "Pokud nemůžete najít odpověď, kterou hledáte, náš tým podpory je připraven pomoci. Můžete nás kontaktovat na:",
      emailLabel: "E-mail:",
      responseTime: "Obvykle odpovídáme do 24–48 hodin",
    },
    bugs: {
      title: "Hlášení chyb",
      body: "Našli jste chybu? Vážíme si vaší pomoci při zlepšování WasOK. Při hlášení chyby prosím uveďte:",
      items: [
        "Podrobný popis problému",
        "Kroky k reprodukci problému",
        "Model vašeho zařízení a verzi Androidu",
        "Snímky obrazovky nebo nahrávky obrazovky, pokud je to možné",
      ],
      sendPrefix: "Hlášení chyb zasílejte na:",
    },
    featureRequests: {
      title: "Návrhy funkcí",
      bodyBefore: "Máte nápad na novou funkci? Rádi si ho poslechneme! Své návrhy zasílejte na",
      bodyAfter:
        ". I když nemůžeme implementovat každý požadavek, při plánování budoucích aktualizací pečlivě zvažujeme veškerou zpětnou vazbu.",
    },
    knownIssues: {
      title: "Známé problémy",
      body: "Aktuálně jsme si vědomi následujících problémů a pracujeme na jejich opravě:",
      items: [
        "Některé čárové kódy se za slabého osvětlení nemusí naskenovat — zkuste použít svítilnu",
        "Uložení velmi dlouhých poznámek k produktům může na starších zařízeních chvíli trvat",
        "Náhledy obrázků mohou na displejích s vysokým rozlišením vypadat rozpixelovaně",
      ],
    },
    appUpdates: {
      title: "Aktualizace aplikace",
      body: "Pravidelně vydáváme aktualizace s novými funkcemi, vylepšeními a opravami chyb. Nezapomeňte udržovat WasOK aktualizovaný prostřednictvím Google Play Store, abyste získali nejnovější vylepšení.",
    },
    community: {
      title: "Komunita",
      body: "Připojte se k naší komunitě uživatelů, kteří s WasOK dělají chytřejší nákupní rozhodnutí. Sdílejte tipy, ptejte se a spojte se s ostatními uživateli na našich sociálních kanálech.",
    },
    emergency: {
      title: "Nouzová podpora",
      body: 'Pokud se potýkáte s kritickým problémem, který vám brání v používání aplikace, označte prosím svůj e-mail v předmětu jako „URGENTNÍ“ a my vaši žádost upřednostníme.',
    },
    cta: {
      heading: "Stále potřebujete pomoc?",
      body: "Náš tým podpory je tu pro vás. Neváhejte se na nás obrátit s jakýmikoli dotazy či obavami.",
      button: "Napsat podpoře",
    },
  },
  advertising: {
    pageTitle: "Reklama a monetizace",
    seoTitle: "Reklama — WasOK",
    seoDescription: "Jak WasOK přistupuje k reklamě a monetizaci.",
    approach: {
      title: "Náš přístup",
      body: "Ve WasOK věříme, že vaše nákupní zvyklosti a názory na produkty jsou soukromé a osobní. Náš obchodní model odráží tuto základní hodnotu.",
    },
    noAds: {
      title: "Žádné reklamy",
      body: "WasOK nezobrazuje žádné reklamy. Nikdy vám nebudeme zobrazovat reklamy na základě produktů, které skenujete, hodnocení, která udělujete, ani žádných jiných dat, která v aplikaci vytváříte. Vaše zkušenost s WasOK je zcela bez reklam.",
    },
    noDataSelling: {
      title: "Žádný prodej dat",
      body: "Vaše data neprodáváme, nepronajímáme ani nesdílíme s inzerenty, datovými brokery ani žádnými třetími stranami. Protože jsou všechna vaše data uložena lokálně ve vašem zařízení, ani my k nim nemáme přístup. Vaše hodnocení produktů, nákupní seznamy a poznámky patří pouze vám.",
    },
    noTracking: {
      title: "Žádné sledování",
      body: "WasOK nepoužívá sledovací pixely, analytické služby ani žádnou jinou technologii, která sleduje vaše chování nebo sdílí informace s třetími stranami. Nesledujeme, jaké produkty skenujete, ve kterých obchodech nakupujete ani jak aplikaci používáte.",
    },
    sustainability: {
      title: "Jak se udržujeme udržitelní",
      body: "Možná se ptáte, jak udržujeme WasOK zdarma bez reklam nebo prodeje dat. Náš přístup je jednoduchý:",
      items: [
        {
          label: "Zdarma a otevřené:",
          text: "WasOK je zdarma pro každého, bez prémiových úrovní nebo placených zdí",
        },
        {
          label: "Úsporný provoz:",
          text: "Udržujeme naše náklady nízké tím, že vytváříme efektivní software zaměřený na soukromí",
        },
        {
          label: "Dobrovolné dary:",
          text: "Uživatelé, kteří WasOK milují, nás mohou podpořit dobrovolnými dary",
        },
        {
          label: "Otevřený zdrojový kód:",
          text: "Můžeme organizacím nabízet konzultační služby nebo vývoj na zakázku",
        },
      ],
    },
    noAffiliate: {
      title: "Žádné affiliate odkazy",
      body: "WasOK nepoužívá affiliate odkazy ani nezískává provize od prodejců. Když naskenujete produkt, nikam vás nepřesměrujeme k jeho koupi. Aplikace slouží čistě k vašim osobním záznamům a rozhodování.",
    },
    noPromotions: {
      title: "Žádná propagace produktů",
      body: "Nepřijímáme platby od značek ani výrobců za propagaci jejich produktů. WasOK vám nikdy nebude navrhovat produkty, zvýrazňovat určité značky ani jakkoli ovlivňovat vaše hodnocení. Vaše názory patří jen vám.",
    },
    partnerships: {
      title: "Partnerství s třetími stranami",
      body: "WasOK nespolupracuje s marketingovými společnostmi, agregátory dat ani reklamními sítěmi. Fungujeme nezávisle a nade vše upřednostňujeme vaše soukromí.",
    },
    future: {
      title: "Plány do budoucna",
      body: "Jsme odhodláni udržet WasOK bez reklam a zaměřený na soukromí. Pokud bychom někdy v budoucnu museli zavést udržitelný obchodní model, uděláme následující:",
      items: [
        "Jakékoli změny oznámíme s dostatečným předstihem",
        "Nikdy neuděláme kompromis v otázce soukromí či bezpečnosti dat",
        "Vždy nabídneme způsob, jak aplikaci používat bez sledování nebo reklam",
        "Budeme naslouchat zpětné vazbě a obavám uživatelů",
      ],
    },
    supporting: {
      title: "Podpora WasOK",
      body: "Pokud máte WasOK rádi a chcete podpořit naše poslání nákupní paměti zaměřené na soukromí, můžete:",
      items: [
        "Říct o aplikaci svým přátelům a rodině",
        "Zanechat pozitivní hodnocení v Google Play Store",
        "Podělit se s námi o zpětnou vazbu a návrhy",
        "Zvážit dobrovolný dar (až bude k dispozici)",
      ],
    },
    cta: {
      heading: "Máte dotazy k našim zásadám?",
      body: "Jsme transparentní ohledně toho, jak WasOK funguje. Pokud máte jakékoli dotazy ohledně našeho přístupu k soukromí, monetizaci nebo udržitelnosti, obraťte se prosím na nás.",
      button: "Kontaktujte nás",
    },
  },
};
